import { AfterViewInit, Component, OnInit } from '@angular/core';
import { LoyaltyParticipantTypeModel, LoyaltyStatusEnum, LoyaltyStatusesModel } from 'app/models';
import { IncentiveQuestService } from 'app/services';
import { Utils } from 'app/utils';
import moment from 'moment';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { IncentiveModel } from './models/incentive.model';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
    selector: 'incentive-quest',
    templateUrl: './incentive-quest.component.html',
    styleUrls: ['./incentive-quest.component.scss',
        '../../../../styles/paginator.scss'],
    providers: [MessageService]
})

export class IncentiveQuestComponent implements OnInit, AfterViewInit {

    // Grid settings
    public rowsPerPage: number = 50;
    public rowsPerPageOptions: Array<number> = [50, 100, 500, 1000];
    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;

    incentiveQuests: Array<IncentiveModel> = [];
    public selectedLoyaltyStatusType: LoyaltyStatusEnum = LoyaltyStatusEnum.All;
    public loyaltyStatusTypes = LoyaltyStatusesModel.LoyaltyStatusList;
    public participantTypes = LoyaltyParticipantTypeModel.LoyaltyParticipantTypes;

    showIncentivePopUp: boolean = false;
    public incentiveModel: IncentiveModel = new IncentiveModel(0, '', '', '', '', 1, LoyaltyStatusEnum.All);
    public selectedIncentiveModel: IncentiveModel | null = null;

    public filter: {
        searchName: string;
    } = { searchName: '' };


    loading: boolean = true;

    public cols: any[] = [
        { field: 'QuestId', header: 'Incentive Quest ID', width: '90px' },
        { field: 'QuestName', header: 'Incentive Quest Name' },
        { field: 'QuestEnds', header: 'Incentive Quest Ends' }
    ];


    constructor(
        private messageService: MessageService,
        private incentiveQuestService: IncentiveQuestService) {
    }

    ngOnInit(): void {
        this.getIncentiveQuests(0);
    }
    ngAfterViewInit(): void {

    }

    public handleLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'QuestId';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        this.getIncentiveQuests(skip);
    }

    public getIncentiveQuests(skip: number): void {
        this.loading = true;

        const dto = {
            Status: this.selectedLoyaltyStatusType,
            TimeZoneOffset: Utils.getTimezoneOffset()
        };

        this.incentiveQuestService.getIncentives(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.first = skip;
                this.incentiveQuests = data.Items;
                this.incentiveQuests.forEach(item => {
                    item.QuestEnds = Utils.utcToLocaleStringDateFormat(item.QuestEnds);
                    item.QuestStarts = Utils.utcToLocaleStringDateFormat(item.QuestStarts);
                });
                this.totalRecords = data.TotalRecords;
                this.loading = false;
                console.log(this.totalRecords);
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public openCreateIncentiveQuest() {

        this.showIncentivePopUp = true;
    }

    public refreshIncentiveModel() {
        this.incentiveModel = new IncentiveModel(0, '', '', '', '', 1, LoyaltyStatusEnum.All);
    }

    public hideIncentiveQuestPopup() {
        this.showIncentivePopUp = false;
        this.refreshIncentiveModel();
    }

    public handleFilterChange(): void {
    }

    public onChangeFilter(): void {
    }

    public clickChangeMenuHomeActive(value: LoyaltyStatusEnum) {
        this.selectedLoyaltyStatusType = value;
    }

    public createLoyaltyIncentive() {
        const dto = {
            Name: this.incentiveModel.QuestName,
            Description: this.incentiveModel.Description,
            StartDate: moment(this.incentiveModel.QuestStarts).format('YYYY-MM-DD'),
            EndDate: moment(this.incentiveModel.QuestEnds).format('YYYY-MM-DD'),
            Participant: this.incentiveModel.Participant.id,
            TimeZoneOffset: Utils.getTimezoneOffset()
        };


        this.incentiveQuestService.addLoyaltyIncentive(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                data.QuestEnds = Utils.utcToLocaleStringDateFormat(data.QuestEnds);
                data.QuestStarts = Utils.utcToLocaleStringDateFormat(data.QuestStarts);
                this.incentiveQuests.push(data);
                this.hideIncentiveQuestPopup();
            });

    }

    public onCardClick(item: IncentiveModel) {
        this.selectedIncentiveModel = item;
    }

    public onBackLinkClick() {
        this.selectedIncentiveModel = null;
    }
}
